import React, { Dispatch, SetStateAction } from 'react'
import { FormDialog } from '../../layout/FormDialog'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'
import AutoCompleteGoogleMapField from './AutoCompleteGoogleMapField'
import ReadOnlyGeoLocationsList from './ReadOnlyGeoLocationsList'

type GeoLocationsDialogProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  mode: 'edit' | 'read'
  name: string
  label: string
  locationType: LocationTypesEnum
  countryCode?: string
  count: number
}

const GeoLocationsDialog: React.FC<GeoLocationsDialogProps> = ({
  open,
  setOpen,
  mode,
  name,
  label,
  locationType,
  countryCode,
  count,
}) => {
  const t = useAppTranslations()
  const titleKey =
    mode === 'edit' ? 'adgroup.geoTargeting.manageLocationsTitle' : 'adgroup.geoTargeting.viewLocationsTitle'

  return (
    <FormDialog open={open} setOpen={setOpen} title={t(titleKey, { count })} maxWidth="md">
      {mode === 'edit' ? (
        <AutoCompleteGoogleMapField
          name={name}
          label={label}
          locationType={locationType}
          countryCode={countryCode}
          disableInlineCap
        />
      ) : (
        <ReadOnlyGeoLocationsList name={name} label={label} locationType={locationType} />
      )}
    </FormDialog>
  )
}

export default GeoLocationsDialog
